import { render, staticRenderFns } from "./bindPhoneModal.vue?vue&type=template&id=02f396f9&scoped=true&"
import script from "./bindPhoneModal.vue?vue&type=script&lang=js&"
export * from "./bindPhoneModal.vue?vue&type=script&lang=js&"
import style0 from "./bindPhoneModal.vue?vue&type=style&index=0&id=02f396f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f396f9",
  null
  
)

export default component.exports